import React from 'react';

export const RotateHandleIcon = ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_657_13175)">
      <circle cx="20" cy="18" r="12" fill="#F9F9F9" />
      <circle cx="20" cy="18" r="11.75" stroke="#C6C6CE" strokeWidth="0.5" />
    </g>
    <path
      d="M18.2501 18.0001C18.2501 18.9684 19.0317 19.7501 20.0001 19.7501C20.9684 19.7501 21.7501 18.9684 21.7501 18.0001C21.7501 17.0317 20.9684 16.2501 20.0001 16.2501C19.0317 16.2501 18.2501 17.0317 18.2501 18.0001Z"
      fill="#90909E"
    />
    <path
      d="M17.6667 16.2501C17.6667 15.9292 17.4042 15.6667 17.0834 15.6667H15.9692C16.7742 14.2726 18.2792 13.3334 20.0001 13.3334C22.0359 13.3334 23.7626 14.6401 24.3984 16.4601C24.4801 16.6876 24.7076 16.8334 24.9467 16.8334C25.3434 16.8334 25.6351 16.4426 25.5067 16.0692C24.7076 13.7942 22.5434 12.1667 20.0001 12.1667C18.0926 12.1667 16.3951 13.0884 15.3334 14.5059V13.9167C15.3334 13.5959 15.0709 13.3334 14.7501 13.3334C14.4292 13.3334 14.1667 13.5959 14.1667 13.9167V16.2501C14.1667 16.5709 14.4292 16.8334 14.7501 16.8334H17.0834C17.4042 16.8334 17.6667 16.5709 17.6667 16.2501Z"
      fill="#90909E"
    />
    <path
      d="M22.3334 19.7501C22.3334 20.0709 22.5959 20.3334 22.9167 20.3334H24.0309C23.2259 21.7276 21.7209 22.6667 20.0001 22.6667C17.9642 22.6667 16.2376 21.3601 15.6017 19.5401C15.5201 19.3126 15.2926 19.1667 15.0534 19.1667C14.6567 19.1667 14.3651 19.5576 14.4934 19.9309C15.2926 22.2059 17.4567 23.8334 20.0001 23.8334C21.9076 23.8334 23.6051 22.9117 24.6667 21.4942V22.0834C24.6667 22.4042 24.9292 22.6667 25.2501 22.6667C25.5709 22.6667 25.8334 22.4042 25.8334 22.0834V19.7501C25.8334 19.4292 25.5709 19.1667 25.2501 19.1667H22.9167C22.5959 19.1667 22.3334 19.4292 22.3334 19.7501Z"
      fill="#90909E"
    />
    <defs>
      <filter
        id="filter0_d_657_13175"
        x="0"
        y="0"
        width="40"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_657_13175"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_657_13175"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
